// src/redux/slices/wizardStepSlice.jsx
import { createSlice } from "@reduxjs/toolkit";

const wizardStepSlice = createSlice({
  name: "wizardstep",
  initialState: {
    step: 1,
    createdProject: [],
    editProjectID: "",
    operationProjectStatus: "",
    wizardPlanState: "",
    wizardProjectState: "",
    existingSearchGroupName: "",
    existingSearchProjectName: "",
    existingSearchClientName: "",
    existingEditAdvancedProject: false,
    existingProjectLeadId: "",
    existingSearchQuotationID: ""
  },
  reducers: {
    resetStep: (state) => {
      state.step = 1;
    },
    goNext: (state) => {
      state.step = state.step + 1;
    },
    goBack: (state) => {
      state.step = Math.max(1, state.step - 1);
    },
    goToStep: (state, action) => {
      state.step = action.payload; // jump to any step
    },
    setCreatedProject: (state, action) => {
      state.createdProject = action.payload; // jump to any step
    },
    setEditProjectID: (state, action) => {
      state.editProjectID = action.payload; // jump to any step
    },
    setWizardPlanState: (state, action) => {
      state.wizardPlanState = action.payload; // jump to any step
    },
    setWizardProjectState: (state, action) => {
      state.wizardProjectState = action.payload; // jump to any step
    },
    setOperationProjectStatus: (state, action) => {
      state.operationProjectStatus = action.payload; // jump to any step
    },
    setExistingSearchGroupName: (state, action) => {
      state.existingSearchGroupName = action.payload; // jump to any step
    },
    setExistingSearchQuotationID: (state, action) => {
      state.existingSearchQuotationID = action.payload; // jump to any step
    },
    setExistingSearchClientName: (state, action) => {
      state.existingSearchClientName = action.payload; // jump to any step
    },
    setExistingSearchProjectName: (state, action) => {
      state.existingSearchProjectName = action.payload; // jump to any step
    },
    setExistingProjectLeadId: (state, action) => {
      state.existingProjectLeadId = action.payload; // jump to any step
    },
    setExistingEditAdvancedProject: (state, action) => {
      state.existingEditAdvancedProject = action.payload; // jump to any step
    },
    clearWizardState: () => {
      return {
        step: 1,
        createdProject: [],
        editProjectID: "",
        operationProjectStatus: "",
        wizardPlanState: "",
        wizardProjectState: "",
        existingSearchGroupName: "",
        existingSearchClientName: "",
        existingSearchProjectName: "",
        existingEditAdvancedProject: false,
        existingProjectLeadId: "",
        existingSearchQuotationID: ""
      };
    }

  }
});

export const {
  resetStep, goNext, goBack, goToStep, setCreatedProject, setEditProjectID, setOperationProjectStatus,
  setWizardPlanState, setWizardProjectState, clearWizardState,
  setExistingSearchGroupName, setExistingSearchClientName, setExistingSearchProjectName,
  setExistingEditAdvancedProject,setExistingProjectLeadId,setExistingSearchQuotationID } = wizardStepSlice.actions;
export default wizardStepSlice.reducer;
